/**
 * Created by Pradeep Kumar on 05/20/2019.
 */

import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {RespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/RespinZeroBetController";
import {TombOfNefertitiGameMode} from "../../gamemode/TombOfNefertitiGameMode";

export class TombOfNefertitiRespinZeroBetController extends RespinZeroBetController {

    /**
     * @description This method will decide whether or not respin is activated or not.
     *
     * @param data
     */
    protected calculateIsTriggered(data:ParsedServerData):boolean {
        return data.nextMode === TombOfNefertitiGameMode.RESPIN;
    }
}